import { FieldValue } from './field.class'

export class StringValue extends FieldValue<string> {
  constructor(value?: string) {
    super()
    this.value = value
  }

  public mapField(field: StringValue): void {
    this.value = field.value
  }

  public toStringForView(): string {
    return this.value ? (this.value as string) : ''
  }
}
